/**
 * Nhãn cho màn hình Quy trình thường (29/10/2026) — đơn KHÔNG chạy quy trình P. Cùng cách đọc với màn P: mỗi bước một chứng từ.
 * Chuỗi bước chốt theo chuẩn bán hàng → thu tiền, khách chưa xác nhận (FLOW-R01) — màn không hiện nhãn, anh Toàn tự hỏi khách.
 */
export const orderProcessEn = {
  title: "Order process",
  intro:
    "Where each order that does not run the P-Process has reached. Every step is read from the documents already in the ledger — nothing is ticked by hand. Steps that do not apply to an order (no purchase, no production) are skipped, and the sales order and the packing list are optional.",
  pLink: "Orders that run the P-Process are on the P-Process screen.",
  normalLink: "Orders that do not run the P-Process are on the Order process screen.",
  empty: "No order yet.",
  error: "Unable to load the order process list.",
  truncated: "Showing the {{count}} newest orders.",
  piNo: "Proforma invoice",
  customer: "Customer",
  date: "Date",
  progress: "Steps",
  current: "Waiting on",
  complete: "All steps done",
  outOfOrder: "Done out of order",
  outOfOrderHint:
    "These steps have a document even though an earlier required step does not — the order skipped a step in the system. Check whether the missing document is needed. Payment before delivery is normal and is not counted here.",
  sourcing: "Sourcing",
  purchased: "Purchased",
  produced: "Produced in-house",
  fromStock: "From stock",
  optional: "Optional",
  deliveryStarted: "Delivery note issued, not delivered yet",
  settlement: { unpaid: "Not paid", partial: "Partly paid", paid: "Paid in full" },
  steps: {
    piIssued: "Proforma invoice",
    salesOrder: "Sales order",
    purchaseOrder: "Purchase order",
    productionOrder: "Manufacturing order",
    goodsReceipt: "Goods received",
    productionOutput: "Finished goods received",
    packing: "Packing list",
    invoice: "Invoice",
    delivery: "Delivered",
    payment: "Paid in full",
  },
};

export const orderProcessVi: typeof orderProcessEn = {
  title: "Quy trình thường",
  intro:
    "Từng đơn KHÔNG chạy quy trình P đang ở bước nào. Mọi bước đọc thẳng từ chứng từ đã có trong sổ — không bước nào tick tay. Bước không áp dụng cho đơn (không mua hàng, không sản xuất) được bỏ qua; đơn bán hàng và phiếu đóng gói là bước tùy chọn.",
  pLink: "Đơn chạy quy trình P xem ở màn Quy trình P.",
  normalLink: "Đơn không chạy quy trình P xem ở màn Quy trình thường.",
  empty: "Chưa có đơn nào.",
  error: "Không tải được danh sách quy trình thường.",
  truncated: "Đang hiện {{count}} đơn mới nhất.",
  piNo: "Hóa đơn chiếu lệ",
  customer: "Khách hàng",
  date: "Ngày",
  progress: "Số bước",
  current: "Đang chờ",
  complete: "Đã xong mọi bước",
  outOfOrder: "Làm nhảy cóc",
  outOfOrderHint:
    "Các bước này đã có chứng từ dù một bước bắt buộc trước đó chưa có — đơn đã bỏ qua một bước trên hệ thống. Kiểm xem chứng từ còn thiếu có cần lập không. Thu tiền trước khi giao là bình thường, không tính ở đây.",
  sourcing: "Nguồn hàng",
  purchased: "Mua hàng",
  produced: "Tự sản xuất",
  fromStock: "Hàng có sẵn",
  optional: "Tùy chọn",
  deliveryStarted: "Đã lập phiếu giao, chưa giao xong",
  settlement: { unpaid: "Chưa thu", partial: "Đã thu một phần", paid: "Đã thu đủ" },
  steps: {
    piIssued: "Hóa đơn chiếu lệ",
    salesOrder: "Đơn bán hàng",
    purchaseOrder: "Đơn mua hàng",
    productionOrder: "Lệnh sản xuất",
    goodsReceipt: "Hàng mua đã nhập kho",
    productionOutput: "Thành phẩm đã nhập kho",
    packing: "Phiếu đóng gói",
    invoice: "Hóa đơn",
    delivery: "Đã giao hàng",
    payment: "Đã thu đủ",
  },
};

export const orderProcessZh: typeof orderProcessEn = {
  title: "常规流程",
  intro: "每张不走 P 流程的订单进行到哪一步。每一步都直接读取账中已有的单据——没有手动打勾。不适用于该订单的步骤（无采购、无生产）会跳过；销售订单和装箱单为可选步骤。",
  pLink: "走 P 流程的订单请在“P 流程”页面查看。",
  normalLink: "不走 P 流程的订单请在“常规流程”页面查看。",
  empty: "暂无订单。",
  error: "无法加载常规流程列表。",
  truncated: "显示最新的 {{count}} 张订单。",
  piNo: "形式发票",
  customer: "客户",
  date: "日期",
  progress: "步骤",
  current: "等待中",
  complete: "全部步骤已完成",
  outOfOrder: "跳步完成",
  outOfOrderHint: "这些步骤已有单据，但之前的某个必需步骤尚无单据——订单在系统中跳过了一步。请检查缺少的单据是否需要补开。送货前收款属正常情况，不计入此处。",
  sourcing: "货源",
  purchased: "采购",
  produced: "自行生产",
  fromStock: "现有库存",
  optional: "可选",
  deliveryStarted: "已开送货单，尚未送达",
  settlement: { unpaid: "未收款", partial: "部分收款", paid: "已收足" },
  steps: {
    piIssued: "形式发票",
    salesOrder: "销售订单",
    purchaseOrder: "采购订单",
    productionOrder: "生产工单",
    goodsReceipt: "采购货物已入库",
    productionOutput: "成品已入库",
    packing: "装箱单",
    invoice: "发票",
    delivery: "已送达",
    payment: "已收足",
  },
};
